// extracted by mini-css-extract-plugin
export var md = "_4f-4";
export var semantic = "_4f-5";
export var sm = "_4f-3";
export var text = "_4f-6";
export var toggleInput = "_4f-0";
export var toggleSwitch = "_4f-1";
export var xs = "_4f-2";